export default __webpack_public_path__ + "static/media/table-responsive-extensive-tables.63e78fbd.svg";